import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationPaddleIncompleteCheckoutPost = {
    path: "/paddle/incomplete-checkout",
    method: ERouteHttpVerb.POST
};
export { routeLocationPaddleIncompleteCheckoutPost };
